import React, { useEffect, useRef, useState } from "react";
import * as powerbi from "powerbi-client";
import LoginButton from "./LoginButton";
import { useMsal } from "@azure/msal-react";

const PowerBIReportEmbedded = ({ reportId, groupId, embedToken }) => {
  
  const reportRef = useRef(null);
  const { instance } = useMsal();

  const [hasWorkspaceAccess, setHasWorkspaceAccess] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [embedToken_n, setEmbedToken_n] = useState(null);

  const getAccountInfo = () => {
  const accounts = instance.getAllAccounts();
    return accounts.length > 0 ? accounts[0] : null;
  };

  const userAuth = getAccountInfo();

  const fetchToken = async () => {

    if (!userAuth) {
      await instance.loginPopup({
        scopes: ["https://analysis.windows.net/powerbi/api/.default"],
      });
    }

    try {
      const tokenResponse = await instance.acquireTokenSilent({
        scopes: ["https://analysis.windows.net/powerbi/api/.default"],
        account: userAuth,
      });

      setEmbedToken_n(tokenResponse.accessToken);
    } catch (error) {
      console.error("Error al obtener el token aqui:", error);
    }
  };

  const validateWorkspaceAccess = async () => {
    try {
      const response = await fetch(
        `https://api.powerbi.com/v1.0/myorg/groups/${groupId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${embedToken_n}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        setHasWorkspaceAccess(true);
        return true;
      }

      if (response.status === 403) {
        setErrorMessage(
          "No cuenta con los permisos necesarios, solicítelo al Data Owner del área de trabajo."
        );
      } else if (response.status === 404) {
        setErrorMessage(
          "No cuenta con los permisos necesarios, solicítelo al Data Owner del área de trabajo."
        );
      } else {
        setErrorMessage(
          "No cuenta con los permisos necesarios, solicítelo al Data Owner del área de trabajo."
        );
      }

      setHasWorkspaceAccess(false);
      return false;
    } catch (error) {
      console.error(error);
      setErrorMessage(
        "No cuenta con los permisos necesarios, solicítelo al Data Owner del área de trabajo."
      );
      setHasWorkspaceAccess(false);
      return false;
    }
  };

  useEffect(() => {

    fetchToken(); //obtiene token

    const powerbiService = new powerbi.service.Service(
      powerbi.factories.hpmFactory,
      powerbi.factories.wpmpFactory,
      powerbi.factories.routerFactory
    );

    const loadReport = async () => {

      setHasWorkspaceAccess(null);
      setErrorMessage("");

      if (reportRef.current) {
        powerbiService.reset(reportRef.current);
      }

      if (!reportId || !groupId || !embedToken_n) {
        return;
      }

      const hasAccess = await validateWorkspaceAccess();

      if (!hasAccess) {
        return;
      }

      const embedConfig = {
        type: "report",
        tokenType: powerbi.models.TokenType.Aad,
        id: reportId,
        embedUrl: `https://app.powerbi.com/reportEmbed?reportId=${reportId}&groupId=${groupId}`,
        accessToken: embedToken_n,
        permissions: powerbi.models.Permissions.All,
        settings: {
          panes: {
            filters: { visible: false },
            pageNavigation: { visible: true },
          },
          layoutType: powerbi.models.LayoutType.FitToWidth,
        },
      };

      try {
        powerbiService.embed(reportRef.current, embedConfig);
      } catch (error) {
        console.error("Error embedding report:", error);
      }
    };

    loadReport();

    return () => {
      if (reportRef.current) {
        powerbiService.reset(reportRef.current);
      }
    };
  }, [reportId, groupId, embedToken_n]);

  if (hasWorkspaceAccess === false) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "20px",
          color: "red",
        }}
      >
        {errorMessage} <br></br><a>Conózcalo a través del siguiente enlace : </a> <a href="https://grupocentenario.sharepoint.com/:fl:/g/contentstorage/CSP_e2750bc5-419c-4700-9179-6714e0a317bc/IQCf7RCtqZ0uSbKVAI6CVC7sAbK44kqPXwrFcKi5D4KP4HA?e=xPcW4f&nav=cz0lMkZjb250ZW50c3RvcmFnZSUyRkNTUF9lMjc1MGJjNS00MTljLTQ3MDAtOTE3OS02NzE0ZTBhMzE3YmMmZD1iJTIxeFF0MTRweEJBRWVSZVdjVTRLTVh2RzFtdENlWjJFTkpuV2l4dkl1NGxVNGZESndjcFB6dlRwekJLbGJBTGVGTSZmPTAxU0RLTDc1TTc1VUlLM0tNNUZaRTNGRklBUjJCRklMWE0mYz0lMkYmYT1Mb29wQXBwJnA9JTQwZmx1aWR4JTJGbG9vcC1wYWdlLWNvbnRhaW5lciZ4PSU3QiUyMnclMjIlM0ElMjJUMFJUVUh4bmNuVndiMk5sYm5SbGJtRnlhVzh1YzJoaGNtVndiMmx1ZEM1amIyMThZaUY0VVhReE5IQjRRa0ZGWlZKbFYyTlZORXROV0haSE1XMTBRMlZhTWtWT1NtNVhhWGgyU1hVMGJGVTBaa1JLZDJOd1VIcDJWSEI2UWt0c1lrRk1aVVpOZkRBeFUwUkxURGMxU2taSFRGRTJNMEZQVkVWR1JrdzFTRlkyVmxSV05FODBXVFElM0QlMjIlMkMlMjJpJTIyJTNBJTIyMWNlZGY2MGYtMGExNi00NTQ4LTlkYmUtY2EyZjlhY2M4ODRjJTIyJTdE">Aquí</a>
      </div>
    );
  }

  return (
    <div
      ref={reportRef}
      style={{
        height: "100%",
        width: "100%",
        border: "1px solid #ddd",
      }}
    >
      {!reportId && !embedToken_n && (
        <p style={{ textAlign: "center", marginTop: "20px", color: "red" }}>
          Faltan los datos necesarios para incrustar el reporte.
        </p>
      )}

      {reportId && !embedToken_n && (
        <p style={{ textAlign: "center", marginTop: "20px", color: "orange" }}>
          <center>
            <LoginButton />
          </center>
        </p>
      )}
    </div>
  );
};

export default PowerBIReportEmbedded;